import { Component } from '@angular/core';
import { FormArray,FormGroup,FormControl,FormBuilder, Validators } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent {
  form:FormGroup;
  mostrar:boolean;
  mostrar2:boolean;
  loading:boolean;

  constructor(private fb:FormBuilder, private authService: AuthService, private router: Router) {
    this.form = this.fb.group({
      email: ['',Validators.required],
      password: ['',Validators.required]
    });

    this.mostrar = false;
    this.mostrar2 = false;
    this.loading = false;
  }

  login() {
    this.mostrar = false;
    this.mostrar2 = false;
    this.loading = true;
    const val = this.form.value;
    let prov = {'email':val.email,'password':val.password};


    if (val.email && val.password) {
      this.authService.login(prov).subscribe(
        (data) => {
          this.loading = false;
        this.router.navigateByUrl('/');
      }
      ,
      (error) => {
        /*error de usuario y clave*/
        console.log('oops', error);
        this.mostrar = true;
        this.loading = false;
      }
    );
  }
  else{
     this.mostrar2 = true;
     this.loading = false;
  }
}

 eliminarAlert(){
  this.mostrar = false;
 }

 eliminarAlert2(){
  this.mostrar2 = false;
 }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/auth/signin/signin.component.ts